import { render, staticRenderFns } from "./headerMob.vue?vue&type=template&id=e55fb484&scoped=true&"
import script from "./headerMob.vue?vue&type=script&lang=js&"
export * from "./headerMob.vue?vue&type=script&lang=js&"
import style0 from "./headerMob.vue?vue&type=style&index=0&id=e55fb484&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55fb484",
  null
  
)

export default component.exports